import React from "react";
// import Image from "next/image";
import styles from "./tickerItem.module.css";
// import flag from "/public/images/flag-of-United-Kingdom.png";
import { getFlag } from "./flagUtills.js";

import PropTypes from 'prop-types';

const TickerItem = (props) => {
  return (
    <div className={styles.ticker_card_item}>
      <div className={styles.flag_container}>
        <img
          // src={`${
          //   process.env.NEXT_PUBLIC_IMAGE_URL
          // }${props.flag.toLowerCase()}.png`}
          src={getFlag(props.flag)}
          alt={props.flag}
          width={25}
          height={18}
          className={`flex ${styles.ticker_flag}`}
          
        />
      </div>
      <p className="">{props.pair} </p>
      <p className=""> {props.rate.toFixed(2)}</p>
    </div>
  );
};

export default TickerItem;
TickerItem.propTypes = {
  flag: PropTypes.string.isRequired,
  pair: PropTypes.string.isRequired,
  rate: PropTypes.any.isRequired,
};
